<template>
    <div
        class="dialog show dialog-spinner"
        data-trigger="#open-simple"
        data-type="simple"
    >
        <div class="loading large"></div>
    </div>
</template>
  
<script>
export default {};
</script>